import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";
import dataHandler from "@Utils/dataHandler";
// Components
import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";
// ModalS
import ConfirmModal from "@Modals/ConfirmModal";
import TypeCompanyCrud from "./Modals/TypeCompanyCrud";

// Styles
import styles from "./styles.module.css";

const TypeCompany = ({ dispatch, companyName, userName }) => {
	const [tableValue, setTableValue] = useState([]);
	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const [openTypeCompanyCrud, setOpenTypeCompanyCrud] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [filteredCount, setfilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);

	const defaultParams = { page: 1, orderKey: "tagId", orderDir: "desc" };
	const url = "typeCompany";

	useEffect(() => {
		(async () => {
			const TypeCompanyPromise = dataHandler({ dispatch, url, params: defaultParams });
			// const companyPromise = dispatch(genericAction("get", "category/all"));
			// const groupsPromise = dispatch(genericAction("get", "groups/all"));

			const [TypeCompanyResponse] = await Promise.all([TypeCompanyPromise]);
			setfilteredCount(TypeCompanyResponse.count);
			setFilteredItems(TypeCompanyResponse.items);
		})();
	}, []);

	// modal handlers
	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenTypeCompanyCrud(true);
	};

	// Table handlers
	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};

	// Table handlers
	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url, params });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setfilteredCount(data.count);
		}
	};

	const apiData = async (name) => {
		switch (name) {
			case "Edit":
				setOpenTypeCompanyCrud(false);
				break;

			case "Eraser":
				setOpenConfirmModal(false);
				await dispatch(genericAction({ method: "delete", route: `${url}/${tableValue.tagId}` }));
				break;
			default:
				break;
		}
		const TypeCompanyResponse = await dataHandler({ dispatch, url, params: defaultParams });
		setfilteredCount(TypeCompanyResponse.count);
		setFilteredItems(TypeCompanyResponse.items);
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Tipo de Compañía">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",

									action: [
										{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
										{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
									],

									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID",
									key: "tagId",
									format: "string",
									dataPosition: "center",
									width: 1,
								},

								{
									label: "Nombre",
									key: "name",
									format: "string",
									headerPosition: "left",
									width: 15,
								},
								// {
								// 	label: "Categoría",
								// 	key: "category.name",
								// 	format: "string",
								// 	dataPosition: "left",
								// 	headerPosition: "center",
								// 	width: 3,
								// },

								// {
								// 	label: "Grupo",
								// 	key: "group.name",
								// 	format: "string",
								// 	dataPosition: "left",
								// 	headerPosition: "left",
								// 	width: 15,
								// },
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={defaultParams}
							dataHandler={handlerData}
							handlerTable={handleButtom}
							addButton={{ label: "Agregar" }}
							searcher={{ width: "40rem" }}
							print={{ printHeader: { company: companyName, title: "Tipo de Compañía", user: userName } }}
						/>
					</div>
				</div>
			</div>
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar"
					buttonLabel="Eliminar"
					content="Está seguro que desea eliminar el Tipo de Compañía"
					focus={tableValue.name}
					onConfirm={() => {
						apiData("Eraser");
					}}
					onDismiss={() => {
						return setOpenConfirmModal(false);
					}}
				/>
			)}

			{openTypeCompanyCrud && (
				<TypeCompanyCrud
					apiData={apiData}
					tableValue={tableValue}
					modalCrud={modalOption}
					tagsList={filteredItems}
					onClose={() => {
						return setOpenTypeCompanyCrud(false);
					}}
					route={url}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		tags: [],
		companyName: company.name,
		userName: user.name,
	};
}

TypeCompany.propTypes = {
	dispatch: PropTypes.func,
	companyName: PropTypes.string,
	userName: PropTypes.string,
};

export default connect(mapStateToProps)(TypeCompany);
